<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="storageIssueDetails.hasPrivilege"
              label="Наличие льготы"
            />
          </v-col>
          <v-col v-if="storageIssueDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.storageIssueDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.storageIssueDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { EMOJI, getValidationErrorText } from '@/utils/validate';
import { checkInvalid, leaveStep, Text } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { StorageIssueStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  components: {
    Footer,
    BankDetails,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    Text,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: cloneDeep(bankDetails),
    storageIssueDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      storageIssueDetails: {
        note: {
          required: requiredIf(() => this.storageIssueDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const SSAD = ServicesModule.statement.storageIssueDetails;

      if (SABD) {
        this.accountBankDetails = { ...this.accountBankDetails, ...SABD };
      }

      if (SSAD) {
        this.storageIssueDetails = {
          ...this.storageIssueDetails,
          ...SSAD,
        };
      }
    },
    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return {
        accountBankDetails: cloneDeep(this.accountBankDetails),
        storageIssueDetails: cloneDeep(this.storageIssueDetails),
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StorageIssueStep.BANK_DETAILS,
      });
    },
  },
};
</script>
